import { AxiosInstance } from 'axios';
import moment from 'moment';
import modifyDeep from '../../../libs/modifyDeep';

const transformDateStringToDateInterceptor = (instance: AxiosInstance) => {
    // modifyDeep(value.data, convertDateStringToDate);
    instance.interceptors.response.use((value) => {
        modifyDeep(value.data, convertDateStringToDate);
        return value;
    });
};

export default transformDateStringToDateInterceptor;

function convertDateStringToDate(key: any, value: any) {
    if (typeof value !== 'string') return value;
    if (!isNaN(+value)) return value;

    if (moment(value, moment.ISO_8601, true).isValid()) {
        return new Date(value);
    }

    return value;
}
